import { jsx as _jsx } from "react/jsx-runtime";
export function Form(props) {
    const handleSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(e);
    };
    return _jsx("form", { onSubmit: handleSubmit, children: props.children });
}
//# sourceMappingURL=Form.js.map